import Dropzone from 'dropzone';
import FetchUtils from '../utils/fetch_utils';
import LayoutUtils from '../utils/layout_utils';

class DocumentUploader {
  initRemoveLinks() {
    document.querySelectorAll('.js-remove-selected-file').forEach(f => {
      const wrap = f.closest('.js-file-field-wrap');
      const addedFile = f.closest('li');
      const id = addedFile.dataset.id;
      this.bindRemoveFileEvent(addedFile, id, wrap);
    });
  }

  init() {
    this.initUploaders();
    this.initRemoveLinks();
  }

  fileAddedHandler(file, wrap) {
    const html = wrap.querySelector('.js-selected-file-template').innerHTML;
    const files = wrap.querySelector('.js-selected-files');
    files.insertAdjacentHTML('beforeend', html);
    const addedFile = files.querySelector('li:last-child');
    addedFile.dataset.name = file.name;
    addedFile.querySelector('.js-name').innerHTML = file.name;
    LayoutUtils.show(addedFile.querySelector('.js-loading'));
  }

  storeUploadedAttachmentId(id, wrap) {
    let attachmentsArray = JSON.parse(wrap.querySelector('.js-uploader-attachments').value);
    attachmentsArray.push(id);
    wrap.querySelector('.js-uploader-attachments').value = JSON.stringify(attachmentsArray);
  }

  bindRemoveFileEvent(addedFile, id, wrap) {
    addedFile.querySelector('.js-remove-selected-file').addEventListener('click', e => {
      e.preventDefault();
      fetch(`/rental_documents/${id}`, {method: 'DELETE', headers: {
        'x-csrf-token': document.querySelectorAll('meta[name=csrf-token]')[0].getAttributeNode('content').value
      }}).then(FetchUtils.checkResponseStatus).then((resp) => {
        return resp.json();
      }).then(() => {
        let attachmentsArray = JSON.parse(wrap.querySelector('.js-uploader-attachments').value);
        attachmentsArray.splice(attachmentsArray.indexOf(id), 1);
        wrap.querySelector('.js-uploader-attachments').value = JSON.stringify(attachmentsArray);
        addedFile.remove();
      }).catch((err) => {
        FetchUtils.handleResponseError(err);
      });
      return false;
    });
  }

  updateFileStatusBarAfterUpload(addedFile) {
    LayoutUtils.hide(addedFile.querySelector('.js-loading'));
    LayoutUtils.show(addedFile.querySelector('.js-success-uploaded'));
    setTimeout(() => {
      LayoutUtils.hide(addedFile.querySelector('.js-success-uploaded'));
      LayoutUtils.show(addedFile.querySelector('.js-remove-selected-file'));
    }, 1000);
  }

  initUploaders() {
    const uploaders = document.querySelectorAll('.js-document-uploader');
    uploaders.forEach(uploader => {
      const wrap = uploader.closest('.js-file-field-wrap');
      new Dropzone(`#${uploader.id}`, {
        url: '/rental_documents',
        paramName: 'attachment',
        acceptedFiles: 'image/*,application/pdf',
        maxFilesize: 5,
        previewsContainer: '.js-selected-files',
        headers: {
          'x-csrf-token': document.querySelectorAll('meta[name=csrf-token]')[0].getAttributeNode('content').value,
        },
        init: function() {
          this.on('sending', function (file, xhr, formData) {
            formData.append('origin', uploader.dataset.origin);
            formData.append('rental_application_id', uploader.dataset.rentalApplicationId);
          });
        },
        addedfile: (file) => {
          this.fileAddedHandler(file, wrap);
        },
        error: function(file){
          FetchUtils.checkResponseStatus(file.xhr);
        },
        complete: (file) => {
          if (file && file.status === 'success') {
            const response = JSON.parse(file.xhr.response);
            const files = wrap.querySelector('.js-selected-files');
            const addedFile = files.querySelector(`li[data-name="${file.name}"]:not(.js-uploaded)`);
            addedFile.classList.add('js-uploaded');
            this.storeUploadedAttachmentId(response.attachment_id, wrap);
            this.updateFileStatusBarAfterUpload(addedFile);
            this.bindRemoveFileEvent(addedFile, response.attachment_id, wrap);
          }
        }
      });
      uploader.querySelector('.js-choose-file-link').addEventListener('click', e => {
        e.preventDefault();
        uploader.click();
        return false;
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.js-document-upload-section')) {
    new DocumentUploader().init();
  }
});
